import { createRecipe } from './runtime.js';

const chatTextShimmerConfig = {"name":"chatTextShimmer","defaultVariants":{"active":true},"variantMap":{"active":["false","true"]}}

export const chatTextShimmer = /* @__PURE__ */ createRecipe(chatTextShimmerConfig)